module.exports = __webpack_public_path__ + "static/media/station06.05434410.jpg";